export enum DistributorUserTypes {
  GET_DISTRIBUTOR_USER = 'GET_DRIVER',
}

export type InitialDistributorUser = distributorUser;
export interface distributorUser {
  username: string;
  email: string;
  distributorUserType: string;
  status: string;
}
